import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["session", "isFromApps"];
var _span, _span2, _span3, _span4, _span5, _span6, _PopperTrigger;
import { useState } from 'react';
import Calendar from '@crehana/compass.icons.outline/Calendar';
import Link from '@crehana/compass.icons.outline/Link';
import MoreVertical from '@crehana/compass.icons.outline/MoreVertical';
import Pin from '@crehana/compass.icons.outline/Pin';
import { cn, Dialog, DialogTrigger, Popper, PopperContent, PopperTrigger, Tag } from '@crehana/compass.ui/v2';
import { CustomNextImage } from '@crehana/next';
import { date } from '@crehana/utils';
import { SessionTimeLineEnum, SessionTypeEnum } from "../../graphql/types/globals.v5";
import useLogEvents from "../../hooks/use-log-events";
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";
import { formatHour, formatTimeZoneSession } from "../../utils/formatDateAndDuration";
import { getLiveSessionImagePlaceholder } from "../../utils/getSessionImagePlaceholder";
import { DeleteSessionModal } from "./DeleteSessionModal";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var DateTimeAndGuests = function DateTimeAndGuests(_ref) {
  var session = _ref.session,
    isAdmin = _ref.isAdmin;
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t,
    languageCode = _useLiveSessionsTrans.languageCode;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-font-body4 tw-text-neutral-light-700 tw-flex tw-items-center tw-gap-0.8 dark:tw-text-neutral-dark-300 tw-mt-0.8 sm:tw-mt-0",
    children: [_span || (_span = /*#__PURE__*/_jsx("span", {
      className: "tw-h-2.4 tw-w-2.4 tw-flex tw-items-center tw-justify-center tw-shrink-0",
      children: /*#__PURE__*/_jsx(Calendar, {
        className: "tw-text-inherit",
        size: 16
      })
    })), /*#__PURE__*/_jsx("span", {
      children: date.format(session.startDate, 'DD/MM/YYYY')
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-hidden sm:tw-flex tw-items-center tw-gap-0.8",
      children: [_span2 || (_span2 = /*#__PURE__*/_jsx("span", {
        className: "tw-text-inherit",
        children: '|'
      })), /*#__PURE__*/_jsxs("span", {
        className: "tw-line-clamp-1",
        children: ["".concat(formatHour(session.startDate, session.endDate, languageCode, session.timeZone, isAdmin || false)), isAdmin && /*#__PURE__*/_jsx("span", {
          className: "tw-ml-0.8",
          children: formatTimeZoneSession(languageCode, session.timeZone)
        }), session.guests > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [_span3 || (_span3 = /*#__PURE__*/_jsx("span", {
            className: "tw-text-inherit tw-mx-0.8",
            children: '|'
          })), /*#__PURE__*/_jsx("span", {
            children: t('DATE_SESSIONS_CARD_GUESTS', {
              interpolation: {
                guests: session.guests
              }
            })
          })]
        })]
      })]
    })]
  });
};
var SessionAddressOrLink = function SessionAddressOrLink(_ref2) {
  var session = _ref2.session,
    isAdmin = _ref2.isAdmin;
  var _useLiveSessionsTrans2 = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans2.t,
    languageCode = _useLiveSessionsTrans2.languageCode;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-font-body4 tw-flex tw-items-center tw-gap-0.8 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300",
    children: [session.type === 'virtual' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [_span4 || (_span4 = /*#__PURE__*/_jsx("span", {
        className: "tw-h-2.4 tw-w-2.4 tw-flex tw-items-center tw-justify-center tw-shrink-0",
        children: /*#__PURE__*/_jsx(Link, {
          className: "-tw-rotate-45 tw-text-inherit",
          size: 16
        })
      })), /*#__PURE__*/_jsx("div", {
        className: "tw-hidden sm:tw-inline-block tw-shrink-0",
        children: t('SESSION_CARD_LINK_PLACEHOLDER')
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-inline-block sm:tw-hidden tw-shrink-0",
        children: t('VIRTUAL')
      })]
    }), session.type === 'location' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [_span5 || (_span5 = /*#__PURE__*/_jsx("span", {
        className: "tw-h-2.4 tw-w-2.4 tw-flex tw-items-center tw-justify-center tw-shrink-0",
        children: /*#__PURE__*/_jsx(Pin, {
          className: "tw-text-inherit",
          size: 16
        })
      })), /*#__PURE__*/_jsx("div", {
        className: "tw-hidden sm:tw-inline-block tw-shrink-0",
        children: session.address
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-inline-block sm:tw-hidden tw-shrink-0",
        children: t('PRESENTIAL')
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex sm:tw-hidden tw-items-center tw-gap-0.8",
      children: [_span6 || (_span6 = /*#__PURE__*/_jsx("span", {
        className: "tw-text-inherit",
        children: '|'
      })), /*#__PURE__*/_jsxs("span", {
        className: "tw-line-clamp-1",
        children: ["".concat(formatHour(session.startDate, session.endDate, languageCode, session.timeZone, isAdmin || false)), isAdmin && /*#__PURE__*/_jsx("span", {
          className: "tw-ml-0.8",
          children: formatTimeZoneSession(languageCode, session.timeZone)
        })]
      })]
    })]
  });
};
var AdminActionButtons = function AdminActionButtons(_ref3) {
  var session = _ref3.session,
    organizationSlug = _ref3.organizationSlug,
    onDeleteSessionClick = _ref3.onDeleteSessionClick;
  var _useLiveSessionsTrans3 = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans3.t;
  var _useLogEvents = useLogEvents(),
    sessionOpenAddGuestListLogEvent = _useLogEvents.sessionOpenAddGuestListLogEvent,
    sessionOpenRegisterAttendanceListLogEvent = _useLogEvents.sessionOpenRegisterAttendanceListLogEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openDialog = _useState2[0],
    setOpenDialog = _useState2[1];
  var handleSessionDelete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onDeleteSessionClick(session.id);
          case 2:
            setOpenDialog(false);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSessionDelete() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleOpenSessionAssignment = function handleOpenSessionAssignment() {
    sessionOpenAddGuestListLogEvent({
      sessionId: session.id,
      sessionType: session.type === 'virtual' ? 'ONLINE' : 'PRESENCE',
      sessionTime: session.timeline
    });
    window.location.href = "/org/".concat(organizationSlug, "/panel/content/lives/").concat(session.id, "/assignment/");
  };
  var handleOpenSessionRegisterAttendance = function handleOpenSessionRegisterAttendance() {
    sessionOpenRegisterAttendanceListLogEvent({
      sessionId: session.id,
      sessionType: session.type
    });
    window.location.href = "/org/".concat(organizationSlug, "/panel/content/lives/").concat(session.id, "/attendance/");
  };
  return /*#__PURE__*/_jsxs(Dialog, {
    open: openDialog,
    onOpenChange: setOpenDialog,
    children: [/*#__PURE__*/_jsxs(Popper, {
      children: [_PopperTrigger || (_PopperTrigger = /*#__PURE__*/_jsx(PopperTrigger, {
        asChild: true,
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "tw-shrink-0",
          children: /*#__PURE__*/_jsx(MoreVertical, {
            className: "dark:tw-text-neutral-light-100",
            size: 24
          })
        })
      })), /*#__PURE__*/_jsx(PopperContent, {
        className: "tw-overflow-hidden",
        removePadding: true,
        align: "start",
        side: "left",
        children: /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-flex-col tw-items-start",
          children: [/*#__PURE__*/_jsx("a", {
            href: "/org/".concat(organizationSlug, "/panel/content/lives/").concat(session.id, "/"),
            className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[220px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
            children: t('SESSION_CARD_CTA_DETAIL')
          }), /*#__PURE__*/_jsx("a", {
            href: "/org/".concat(organizationSlug, "/panel/content/lives/").concat(session.id, "/edit/?from=lives-list"),
            className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[220px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
            children: t('SESSION_CARD_CTA_EDIT')
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: handleOpenSessionAssignment,
            className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[220px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
            children: t('SESSION_CARD_CTA_ADD_USERS')
          }), session.timeline === SessionTimeLineEnum.PAST && /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: handleOpenSessionRegisterAttendance,
            className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[220px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
            children: t('SESSION_CARD_CTA_ASSISTANCE')
          }), /*#__PURE__*/_jsx(DialogTrigger, {
            asChild: true,
            children: /*#__PURE__*/_jsx("button", {
              className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[220px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
              type: "button",
              children: t('SESSION_CARD_CTA_DELETE')
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(DeleteSessionModal, {
      sessionTitle: session.title,
      onDelete: handleSessionDelete
    })]
  });
};
export var LiveSessionCardDeprecated = function LiveSessionCardDeprecated(_ref5) {
  var session = _ref5.session,
    isFromApps = _ref5.isFromApps,
    otherProps = _objectWithoutProperties(_ref5, _excluded);
  var _useLiveSessionsTrans4 = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans4.t;
  var goToSessionDetailCollaborator = function goToSessionDetailCollaborator() {
    var baseUrl = window.location.origin;
    if (isFromApps) {
      window.open("".concat(baseUrl, "/org/").concat(otherProps.organizationSlug, "/live-sessions/").concat(session.id, "/?isFromApps=true"), '_blank');
    }
    window.open("".concat(baseUrl, "/org/").concat(otherProps.organizationSlug, "/live-sessions/").concat(session.id, "/"), '_blank');
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-p-1.6 tw-flex tw-flex-col tw-items-end tw-gap-1.6 sm:tw-items-center  sm:tw-flex-row tw-relative', !otherProps.isAdmin && 'tw-rounded-1 tw-border tw-border-solid border tw-border-transparent hover:tw-border-primary-light-300'),
    children: [!otherProps.isAdmin && /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: function onClick() {
        return goToSessionDetailCollaborator();
      },
      className: "tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-right-0 tw-z-7 tw-cursor-pointer"
    }), /*#__PURE__*/_jsx("div", {
      className: "tw-relative tw-overflow-hidden tw-shrink-0 tw-w-full tw-h-16 sm:tw-h-[90px] sm:tw-w-[140px]",
      children: /*#__PURE__*/_jsx(CustomNextImage, {
        className: "tw-rounded tw-object-cover",
        src: getLiveSessionImagePlaceholder({
          eventType: session.type === 'virtual' ? SessionTypeEnum.ONLINE : SessionTypeEnum.PRESENCE,
          imageUrl: session.imageUrl
        }),
        layout: "fill",
        objectFit: "cover"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-grow tw-space-y-0.8 tw-w-full tw-flex tw-items-center tw-justify-between sm:tw-h-[90px]",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tw-h-full tw-flex tw-flex-col tw-justify-between tw-w-full",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-items-center tw-justify-between tw-mb-1.2 sm:tw-mb-0 tw-w-full",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "tw-font-subtitle3 tw-text-neutral-light-800 dark:tw-text-neutral-light-100 tw-line-clamp-1",
            children: session.title
          }), session.origin === 'course' && /*#__PURE__*/_jsx(Tag, {
            className: "tw-shrink-0",
            children: t('SESSION_IN_COURSE_TAG')
          })]
        }), /*#__PURE__*/_jsx(SessionAddressOrLink, {
          session: session,
          isAdmin: otherProps.isAdmin
        }), /*#__PURE__*/_jsx(DateTimeAndGuests, {
          session: session,
          isAdmin: otherProps.isAdmin
        })]
      }), otherProps.isAdmin && /*#__PURE__*/_jsx(AdminActionButtons, _objectSpread({
        session: session
      }, otherProps))]
    })]
  });
};